import { routes } from "../../../config/routes";
import { OfferAzureSearch } from "library/types/types_old";
import { Flex } from "components/styled";
import { Link } from "@fluentui/react-components";

export const LicensePlateCell = ({ offer }: { offer: OfferAzureSearch }) => {
  return offer?.VehicleLicensePlate ? (
    <>
      <Flex gap={5}>
        <Link href={`/offer/${offer.OfferId}`}>
          <div
            style={{
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
          >
            {offer.VehicleLicensePlate}
          </div>
        </Link>
      </Flex>
    </>
  ) : null;
};
